import ApiClient from './ApiClient';

class LocationClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async getLocations() {
    try {
      return await this.get('/location');
    } catch (error) {
      throw new Error(`Failed to get locations`);
    }
  }

  async addLocation(data) {
    try {
      return await this.post('/location', data);
    } catch (error) {
      throw new Error(`Failed to add location: ${error.message}`);
    }
  }

  async getLocationsCalculations() {
    try {
      return await this.get('/location/calculations');
    } catch (error) {
      throw new Error(`Failed to get locations calculations`);
    }
  }
}

export default LocationClient;
